<pbc-sorter [config]="ZeitUnterartsSorterConfig" [sorter]="zeitUnterarts.sorter$ | async" (sorterChange)="zeitUnterarts.sorter$.next($event)"></pbc-sorter>
